import * as XLSX from 'xlsx';
import toast from 'react-hot-toast';
import { getallorders } from '../../../../shared/services/apiorder/apiorder';

export const exportToExcel = async () => {
    try {
        const response = await getallorders({ first: 0, rows: 100000, globalfilter: '', colfilter: {} });
        if (!response?.resdata) {
            throw new Error('No data received');
        }
        
        const ordersToExport = response.resdata.map(order => ({
            'Order ID': order.Order_id || '',
            'Invoice ID': order.Invoice_ID || '',
            'Order Date': order.Order_Date ? new Date(order.Order_Date).toLocaleString() : '',
            'Billing Name': order.Billing_Name || '',
            'Email': order.Email || '',
            'Mobile Number': order.Mobilenumber || '',
            'Delivery Address': order.Delivery_Address || '',
            'City': order.City || '',
            'State': order.State || '',
            'Country': order.Country || '',
            'Zipcode': order.Zipcode || '',
            'Payment Status': order.Payment_Status || '',
            'Order Status': order.Order_Status || '',
            'Total Amount': order.Total_Amount || 0,
            'Payment ID': order.Payment_Id || '',
            'Payment Date': order.Payment_Date ? new Date(order.Payment_Date).toLocaleString() : '',
            'Failed Reason': order.failed_reason || '',
            'Created At': order.createdAt ? new Date(order.createdAt).toLocaleString() : '',
            'Updated At': order.updatedAt ? new Date(order.updatedAt).toLocaleString() : ''
        }));

        // Create worksheet and set column widths
        const worksheet = XLSX.utils.json_to_sheet(ordersToExport);
        
        // Set column widths
        const columnWidths = [
            { wch: 25 }, // Order ID
            { wch: 20 }, // Invoice ID
            { wch: 20 }, // Order Date
            { wch: 25 }, // Billing Name
            { wch: 30 }, // Email
            { wch: 15 }, // Mobile Number
            { wch: 60 }, // Delivery Address
            { wch: 15 }, // City
            { wch: 15 }, // State
            { wch: 15 }, // Country
            { wch: 10 }, // Zipcode
            { wch: 15 }, // Payment Status
            { wch: 20 }, // Order Status
            { wch: 15 }, // Total Amount
            { wch: 25 }, // Payment ID
            { wch: 20 }, // Payment Date
            { wch: 50 }, // Failed Reason
            { wch: 20 }, // Created At
            { wch: 20 }  // Updated At
        ];
        worksheet['!cols'] = columnWidths;

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Orders');
        
        // Generate and download the file
        const fileName = `orders_export_${new Date().toISOString().split('T')[0]}.xlsx`;
        XLSX.writeFile(workbook, fileName);
        toast.success('Orders exported successfully');
    } catch (error) {
        console.error('Export failed:', error);
        toast.error('Failed to export orders');
        throw error;
    }
};